import { defineStore } from "pinia";
import { ref, computed } from "vue";
import { setUser as setSentryUser } from "@sentry/vue";

export const useUserStore = defineStore("user", () => {
  const user = ref(null);
  const language = ref("en");
  const isPerTonneView = ref(true);

  const setUser = (data) => {
    user.value = data;
    language.value = data.language;
    setSentryUser(data.cuid ? { id: data.cuid } : null);
  };
  const isCompanyType = (type) => user.value?.company?.type === type;
  const isCompanyJurisdiction = (jurisdiction) => user.value?.company?.jurisdiction === jurisdiction;
  const hasProductAccess = (...products) => {
    const company = user.value?.company;
    const licenses = company?.licenses || [];
    return licenses.some(
      (license) => license.plan !== "FREE" && (!products.length || products.includes(license.product)),
    );
  };
  const showTour = ref(true);
  const isLoggedIn = computed(() => !!user.value);
  const csrfToken = computed(() => user.value?.csrfToken);

  return {
    user,
    language,
    csrfToken,
    setUser,
    isLoggedIn,
    isCompanyType,
    isCompanyJurisdiction,
    hasProductAccess,
    showTour,
    isPerTonneView,
  };
});
